import './checkbox-filter.css';
import { h } from 'preact';

import CheckboxChoice from './components/CheckboxChoice/CheckboxChoice';

export default function CheckboxFilter({ id, label, name, value, choices, getMatchCount, onChangeHandler }) {
	return (
		<div class={'filter-container checkbox-filter-container filter-container-' + name.replace(/\s/g, '-').toLowerCase()}>
			<fieldset class="filter-fieldset-container checkbox-filter-filter-container">
				<legend class="filter-label">{label}</legend>
				{choices.length > 0 ?
					<ul class="filter-choices-container">
						{choices.map(choice => (
							<CheckboxChoice
								id={`${id}-${choice.value}`}
								name={name}
								text={choice.text}
								value={choice.value}
								isChecked={Array.isArray(value) && value.filter(value => value === choice.value).length === 1}
								onChangeHandler={onChangeHandler}
								matchCount={getMatchCount(name, [choice.value])}
							/>
						))}
					</ul>
					: ''}
			</fieldset>
		</div>
	);
}
